import React from 'react'
import {
  Switch,
  Route,
} from "react-router-dom";

import ClientLayout from '@/layouts/default'

import Home from '@/pages/home'
import About from '@/pages/about'
import Article from '@/pages/article'

// import './style.less'

class ClientRouters extends React.Component {
  render () {
    return (
      <ClientLayout>
        <Route exact path="/"><Home /></Route>
        <Route path="/about"><About /></Route>
        <Route path="/article/:articleId"><Article /></Route>
      </ClientLayout>
    )
  }
}

export default ClientRouters